// Generate a stable device fingerprint for anti-fraud signals.
// Cached in localStorage so we don't pay the FingerprintJS init cost on every call.

const STORAGE_KEY = 'device_fp_v1';

let pending: Promise<string> | null = null;

function readCached(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

function writeCached(value: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch {
    /* localStorage blocked — silent */
  }
}

/** Synchronous read — returns the cached fingerprint without computing. */
export function getDeviceFingerprintSync(): string | undefined {
  const v = readCached();
  return v || undefined;
}

export async function getDeviceFingerprint(): Promise<string | undefined> {
  const cached = readCached();
  if (cached) return cached;

  if (pending) return pending;

  pending = (async () => {
    try {
      // Lazy import — avoid loading FingerprintJS if never called
      const FingerprintJS = await import('@fingerprintjs/fingerprintjs');
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      const visitorId = (result.visitorId || '').slice(0, 50);
      if (visitorId) writeCached(visitorId);
      return visitorId;
    } catch {
      return '';
    } finally {
      pending = null;
    }
  })();

  const value = await pending;
  return value || undefined;
}
